var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "link",
    d: "M14-5.281V.5a1.447,1.447,0,0,1-.437,1.063A1.447,1.447,0,0,1,12.5,2H1.5A1.447,1.447,0,0,1,.438,1.563,1.447,1.447,0,0,1,0,.5v-11a1.447,1.447,0,0,1,.438-1.062A1.447,1.447,0,0,1,1.5-12H9.25a.723.723,0,0,1,.531.219l.5.5a.7.7,0,0,1,.156.813A.685.685,0,0,1,9.75-10H2V0H12V-4.781a.723.723,0,0,1,.219-.531l.5-.5a.7.7,0,0,1,.813-.156A.685.685,0,0,1,14-5.281Zm4-7.562v4.969a.848.848,0,0,1-.25.625.848.848,0,0,1-.625.25h-.562a.847.847,0,0,1-.453-.125.858.858,0,0,1-.312-.328.94.94,0,0,1-.109-.453L15.75-10,8.031-2.219A.723.723,0,0,1,7.5-2a.723.723,0,0,1-.531-.219l-.75-.75A.723.723,0,0,1,6-3.5a.723.723,0,0,1,.219-.531L14-11.75l-2.094.063a.9.9,0,0,1-.641-.25A.823.823,0,0,1,11-12.562v-.562a.848.848,0,0,1,.25-.625.848.848,0,0,1,.625-.25h4.969a1.111,1.111,0,0,1,.813.344A1.111,1.111,0,0,1,18-12.844Z",
    transform: "translate(0 14)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.5d190763344f4a8831669b4841fccfb5.svg";
export { ForwardRef as ReactComponent };